import { render } from "./global-campus.vue?vue&type=template&id=1af9adef"
import script from "./global-campus.vue?vue&type=script&lang=js"
export * from "./global-campus.vue?vue&type=script&lang=js"

import "./global-campus.vue?vue&type=style&index=0&id=1af9adef&lang=scss"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__